const Lang = {
  "global.lang": "فارسی",
  "global.networkerror": "شبکه قطع است. لطفا دوباره تلاش کنید.",
  "global.loading": "در حال بارگذاری...",

  "global.fa": "فارسی",
  "global.zh": "Chinese",
  "global.en": "English",
  "global.ja": "Japanese",

  cancel: "لغو",
  confirm: "تایید",

  BSV: "BSV",
  BTC: "BTC",
  LATEST: "آخرین",

  "unit.set": "set",

  // login
  login: "ورود",
  register: "ثبت نام",
  forgetPassword: "فراموشی رمز عبور",
  reset: "پاکسازی",
  returnToLogin: "ورود",
  //
  newPassword: "رمز عبور، ۸-۱۶ کاراکتر",
  rePassword: "تایید رمز عبور",
  next: "بعدی",
  enterCode: "کد فعال‌سازی",
  getCode: "ارسال",
  loginType: "ایمیل یا شماره همراه",
  goLogin: "ورود",
  forgetSuccess: "رمز عبور با موفقیت تغییر نوسازی شد.",
  NoMailTips:
    "If the verification code is not received, it may be added to the blacklist by the operator. Please contact customer service.",
  passwordPlaceholder: "رمز عبور ۸-۱۶ کاراکتر",
  phonePlaceholder: "لطفا شماره همراه یا ایمیل خود را وارد کنید",
  registerSuccess: "ثبت نام با موفقیت انجام شد",
  UserAgreement: "شرایط استفاده اکساتوشی",
  PrivacyPolicy: "سیاست حفظ حریم خصوصی",
  SignAgreement: "برای ثبت نام باید با شرایط دو لینک روبرو موافق باشید:",
  NoAccount: " ",
  HaveAccount: " ",
  NowLogin: "Login now",
  NowRegister: "Register now",
  LoginBannerTitle1: "Better Bitcoin",
  LoginBannerTitle2: "mining experience",
  LoginBannerTip: "More benefits, safe and stable",

  "meta.homeTitle": "Mempool矿池-全球收益领先的BSV/BTC/BCH的比特币矿池",
  "meta.homeDescription":
    "Mempool矿池全网收益第一，提供BSV/BTC/BCH矿池挖矿服务，实现您轻松挖矿，为您收益保障护航。",
  "meta.homeKeyword": "比特币矿池、BSV矿池",

  //资金管理
  "fund.accountAddressTipsBTC": "لطفا از آدرس کیف پول حساب اصلی BTC خود استفاده کنید",
  "fund.accountAddressTips": "لطفا از آدرس کیف پول حساب اصلی  خود استفاده کنید",
  "fund.LastModifiedTime": "زمان آخرین تغییر	",
  "fund.Set": "تنظیم",
  "fund.NoWithdraw": "بدون برداشت اتوماتیک",
  "fund.Daily": "برداشت روزانه",
  "fund.tipsBTCLeft": "برای برداشت به مقدار >=",
  "fund.tipsBTCRight": "BTC، برداشت اتوماتیک روزانه ساعت ۱۰ صبح به آدرس ثبت شده انجام می‌شود.",
  "fund.tipsBSVLeft": "برای برداشت به مقدار >=",
  "fund.tipsBSVRight": "BSV برداشت اتوماتیک روزانه ساعت ۱۰ صبح به آدرس ثبت شده انجام می‌شود.",
  "fund.Save": "ذخیره",
  "fund.Cancel": "لغو",
  "fund.BTCToBSV": "BTC به BSV",
  "fund.noExchange": "بدون تبدیل اتوماتیک",
  "fund.dailyExchange": "تبدیل روزانه",
  "fund.moneyExchange": "تبدیل طبق مقدار",
  "fund.time": "مقدار",
  "fund.day": "روز",
  "fund.MinExchange": "کمترین مقدار برای تبدیل ۰.۰۱ BTC است.",
  "fund.ExTime": "زمان انجام",
  "fund.SubAccount": "حساب فرعی",
  "fund.Balance": "درآمد",
  "fund.Address": "آدرس",
  "fund.Operation": "عملیات",
  "fund.BTCButton": "برداشت BTC",
  "fund.BSVButton": "برداشت BSV",
  "fund.BTCTOBSV": "تبدیل",
  "fund.Monthly_bill": "صورتحساب ماهانه",
  "fund.WithdrawAddress": "تنظیمات آدرس برداشت",
  "fund.setWithdraw": "تنظیمات برداشت اتوماتیک",
  "fund.ExchangeSetting": "تنظیمات تبدیل",
  "fund.Last24hours": "درآمد آخرین روز",
  "fund.Cumulative": "کل درآمد",
  "fund.TreasuryCurrent": "ارزش خزانه",
  "fund.Detail": "جزییات",
  "fund.Exchange": "هر تبدیل",
  "fund.BTCtopTips": "لطفا آدرس کیف پول BTC خود را وارد کنید.",
  "fund.BSVtopTips": "لطفا آدرس کیف پول BSV خود را وارد کنید.",
  "fund.NoMailTips":
    "لطفا در صورتی که کد تایید را دریافت نکردید، پس از بررسی شماره وارد شده با پشتیبانی اکساتوشی مکاتبه کنید.",
  "fund.NoAddress": "بدون آدرس",
  "fund.BalanceTips": "کل موجودی قابل برداشت تمام حساب‌ها",
  "fund.CumulativeTips": "کل درآمد حاصل شده از تمامی حساب‌ها",
  "fund.AddressTips1": "آدرش برداشت BTC و BSV",
  "fund.AddressTips2": "حساب‌های فرعی جدید بصورت پیش فرض از این آدرس‌ها استفاده خواهند کرد.",
  "fund.AddressTips3":
    "هر حساب فرعی می‌تواند از طریق [حساب فرعی] -> [تنظیمات] برای خود یک آدرس جدید تعریف کند.",
  "fund.setWithdrawTips1": "می‌توانید برداشت اتوماتیک را برای BTC و BSV فعال کنید.",
  "fund.setWithdrawTips2": "حساب‌های فرعی جدید بصورت پیش فرض از این تنظیمات استفاده خواهند کرد.",
  "fund.setWithdrawTips3":
    "هر حساب فرعی می‌تواند از طریق [حساب فرعی] -> [تنظیمات] برای خود تنظیمات برداشت متفاوتی تنظیم کند.",
  "fund.ExchangeSettingTips1": "فعلا تبدیل BTC به BSV را پشتیبانی می‌کند.",
  "fund.ExchangeSettingTips2":
    "حساب‌های فرعی جدید بصورت پیش فرض از این تنظیمات استفاده خواهند کرد.",
  "fund.ExchangeSettingTips3":
    "هر حساب فرعی می‌تواند از طریق [حساب فرعی] -> [تنظیمات] برای خود تنظیمات تبدیل متفاوتی تنظیم کند.",
  "fund.AutoWithdrawDayTip":
    "تبدیل یکبار در روز، وقتی موجودی حساب BTC به زمان و مقدار مشخصی که الان تنظیم می‌کنید برسد به BSV تبدیل خواهد شد.",
  "fund.AutoWithdrawTimeTip":
    "تبدیل بر مبنای هر بار که موجودی حساب BTC به مقدار مشخصی که الان تنظیم می‌کنید برسد، بصورت اتوماتیک به BSV تبدیل شود.",
  "fund.Current": "فعلی",
  "fund.SameAccount": "Consistent with the primary account",
  "fund.dayChange": "تبدیل روزانه",
  "fund.Mining": "ماینینگ",
  "fund.MonitorAlarm": "تنظیمات مانیتورینگ",
  "fund.Watcher": "ناظر",
  "fund.none": "بدون داده",
  "fund.MonitorOpen": "مانیتورینگ روشن است",
  "fund.MonitorClose": "مانیتورینگ بسته است",
  "fund.moreHeigher": " بیشتر است به مقدار",
  "fund.better": "درآمد",

  //共享费率
  "treasury.HandleFee": "Block Reward - Fees",
  "treasury.Deposit": "Deposit",
  "treasury.Withdrawal": "Withdraw",
  "treasury.PaymentFPPS": "Payment - FPPS",
  "treasury.BlockReward": "Block reward",
  "treasury.ColdWallet": "Cold wallet transfer out",
  "treasury.HotWallet": "Hot wallet into",
  "treasury.FundsFallback": "Funds fallback",
  "treasury.PayingFPPS": "Paying - FPPS",
  "treasury.PaymentBTC": "Payment-BTC Hashrate",
  "treasury.LockReward": "Lock reward",
  "treasury.ToBeConfirm": "Waiting for confirmation",
  "treasury.Refuse": "Refuse",
  "treasury.Confirm": "Confirmed",

  "treasury.Processing": "Processing",
  "treasury.Paid": "Paid",
  "treasury.PerHour": "Per hour",
  "treasury.PerMinute": "Per minute",
  "treasury.PerDay": "Per day",
  "treasury.ExchangeEchart": "BSV Exchange rate chart",
  "treasury.ChangePoolRecord": "Treasury changes",
  "treasury.ChangePoolRecordTip": "Records of miners paid and block rewards received",
  "treasury.RecordList": "Deposit and withdrawal history",
  "treasury.All": "All",
  "treasury.ChangeType": "Type",
  "treasury.Time": "Time",
  "treasury.Amount": "Amount",
  "treasury.BlockInfo": "Info",
  "treasury.Height": "Height",
  "treasury.Conf": "CONF",
  "treasury.DepositBSV": "Deposit BSV",
  "treasury.WithdrawalBSV": "Withdraw BSV",
  "treasury.Record": "My History",
  "treasury.DepositHistroy": "Deposit",
  "treasury.WithdrawHistroy": "Withdraw",
  "treasury.Status": "Status",
  "treasury.TXID": "TXID",
  "treasury.More": "All",
  "treasury.Mine": "Mine",
  "treasury.Investment income": "Investment income",
  "treasury.Proportion": "Proportion",
  "treasury.Lock BSV": "Lock BSV",
  "treasury.Tips": "New block must be transferred to the account after 100 confirmations.",
  "treasury.EarnTips": "Lock BSV included",
  "treasury.Exchangerate": "Exchange rate chart",
  "treasury.Progress": "Progress",
  "treasury.address": "آدرس",
  "treasury.Present Value": "Present Value",
  "treasury.Current Treasury": "Current Treasury",

  "treasury.MyBalance": "Snapshot of my balance",
  "treasury.MyBalanceTip": "Balance = Deposit + Unlocked - Paid FPPS - Withdrawal",
  "treasury.PoolBalance": "Snapshot of Treasury balance",
  "treasury.Blocks": "Block statistics",
  "treasury.BSVBlocks": "BSV blocks",
  "treasury.PersonalRecord": "My funds changes",
  "treasury.PoolRecord": "Treasury changes",
  "treasury.percent": "Withdrawal precent ",
  "treasury.percentAmount": "Estimated withdrawal",
  "treasury.sevenDay": "7 days",
  "treasury.mounth": "30 days",
  "treasury.3mounth": "90 days",
  "treasury.6mounth": "180 days",
  "treasury.all": "all",

  fees: "هزینه برق",
  machineName: "نوع",
  power: "قدرت هش",
  consumption: "برق مصرفی",
  "Unit power consumption": "قدرت دستگاه",
  "Daily output": "درآمد در ۲۴ ساعت",
  "Daily electricity fee": "هزینه برق",
  "Electricity cost ratio": "درآمد بر مصرف",
  "Net profit/T/day": "سود خالص در روز",
  "payback period": "دوره پرداخت",
  "login.miner": "انتخاب ماینر ",
  "login.input": "قیمت را وارد کنید",
  "login.payoff": "روز تسویه",
  "login.rank": "رتبه بندی",
  "login.update": "به روزررسانی اطلاعات در",
  "login.dayEarn": "درآمد روزانه",
  "login.okex": "قیمت ارزهای کریپتو هر روز ساعت ۸ صبح مطابق با صرافی Okex به روز رسانی میشود.",
  "login.totalPower": "قدرت ماینر",
  "login.dailyEarn": "درآمد روزانه بر اساس PPS/T",

  "login.appText1": "مشاهده جزئیات بیشتر ماینینگ حساب‌های مختلف، ",
  "login.appText2": "عملیات برداشت دستی از حساب توسط ماینر, مشاهده ماینر، ",
  "login.appText3": "تنظیمات حساب فرعی،",
  "login.appText4": "watcher account بازدید ",
  "login.IOS": "سیستم عامل IOS",
  "login.Android": "سیستم عامل اندروید",

  "login.InfoTitle": "بیشتر بدانید",
  "login.Info1": "برداشت دستی",
  "login.Info1_text": "برداشت دستی، امنیت بالا و نرخ بازگشت پایدار",
  "login.Info2": "ماینینگ هوشمند",
  "login.Info2_text":
    "انتخاب ماینینگ هایی که به صورت اتوماتیک درآمد بیشتری از ماینینگ به دست می‌آورند، با  قابلیت سویچ از BTC به BSV و برعکس",
  "login.Info3": "کارمزد ۰ درصد",
  "login.Info3_text":
    "با پیوستن به استخر اکساتوشی میتوانید با کارمزد صفر درصد از خدمات ویژه استفاده کنید. ",
  "login.Info4": "خدمات ممتاز",
  "login.Info4_text":
    "تیم فنی باتجربه و حرفه ای، پشتیبانی ۲۴ ساعته، تضمین پایداری سیستم، بدون کاهش درآمد ",

  "login.FAQ": "سوالات متداول",
  "login.Q1": "چطور سود خود را به صورت دستی برداشت کنیم؟",
  "login.A1_1":
    "به صفحه مربوط به درآمدها مراجعه کنید و روی «برداشت» کلیک کنید تا درخواست برداشت شما ثبت شود.",
  "login.A1_2": "به محض ثبت درخواست، سیستم در اسرع وقت مبلغ را به حساب شما واریز میکند.",
  "login.Q2": "حداکثر میزان برداشتی سیستم به طور اتوماتیک چقدر است؟",
  "login.A2_1": "حداکثر میزان برداشتی برای بیتکوین مقدار ۰.۰۱ BTC است.",
  "login.A2_2": "حداکثر میزان برداشتی برای BSV ۰.۰۱ است.",
  "login.A2_3": "سیستم ما قابلیت پشتیبانی از مقدار کسر سفراشی BTC و BSV را دارد.",
  "login.Q3": "چرا درآمد حاصل از ماینینگ تغییر میکند؟",
  "login.A3":
    "توجه داشته باشید که به طور کل، میزان سختی شبکه بیتکوین در هر ۲۰۱۶ بلاک کمی تغییر میکند و کاهش یا افزایش میزان هش ریت ماینرها امری طبیعی است. ",
  "login.Q4": "چرا درآمد حاصل از ماینینگ هنوز به حساب من اضافه نشده؟",
  "login.A4":
    "درآمد حاصل از ماینینگ به صورت روزانه یک بار به حساب شما واریز میشود. واریز سود یک روز بعد حدود ساعت ۱۲ تا ۴ توسط اکساتوشی انجام میشود. میتوانید جزئیات مربوط به واریز را در صفحه درآمدها مشاهده کنید.",

  // Heard
  "Header.dropdown.set": "تنظیمات حساب کاربری",
  "Header.dropdown.exit": "خروج از پنل",
  "Header.Dashboard": "داشبورد",
  "Header.ShareFees": "خزانه",
  "Header.AgentManagement": "مدیریت همکار",
  "Header.AgentCreate": "افزودن همکار",
  "Header.Tools": "ابزارها",
  "Header.Report": "گزارش",
  "Header.Watcher": "ناظر",
  "Header.Money": "سرمایه",
  "Header.More": "بیشتر",

  // 账户设置
  "LoginLog.Title": "گزارش ورود",
  "LoginLog.TitleTip":
    "فقط ۵ ورود آخر نمایش داده می‌شود. برای اطلاع از موارد بیشتر با پشتیبانی اکساتوشی تماس بگیرید.",
  "LoginLog.TableTime": "زمان",
  "LoginLog.TableCity": "شهر",
  "LoginLog.TableIP": "IP",
  "LoginLog.Security": "امنیت",
  "LoginLog.Password": "رمز عبور",
  "LoginLog.GoogleTitle": "ورود دو مرحله‌ای با گوگل",
  "LoginLog.Open": "باز",
  "LoginLog.Closed": "غیرفعال",
  "LoginLog.weChatQRCode": "QR Code",
  "LoginLog.weChat": "WeChat Official Accounts",
  "LoginLog.weChatTips":
    "Pay attention to the WeChat Official Accounts, bind your mempool account to get message notification in real time.",
  "LoginLog.CodeTip":
    "برای برداشت از حساب و تنظیم آدرس حساب به کد ۶ رقمی تایید (Google Authenticator) نیاز خواهید داشت.",
  "LoginLog.OtherSetting": "سایر تنظیمات",
  "LoginLog.ChooseTime": "انتخاب محدوده زمانی",
  "LoginLog.ChangePassword": "تغییر رمز عبور",
  "LoginLog.OldPassword": "رمز عبور قبلی",
  "LoginLog.NewPassword": "رمز عبور جدید",
  "LoginLog.ConfirmNewPassword": "تکرار رمز جدید",
  "LoginLog.On": "فعالسازی ورود دو مرحله‌‌ای با گوگل",
  "LoginLog.Off": "غیرفعالسازی ورود دو مرحله‌ای با گوگل",
  "LoginLog.Section1": "۱. نرم افزار Goolge Authenticator را بر روی گوشی خوب نصب کنید.",
  "LoginLog.Section2":
    "۲. نرم افزار Google Authenticator را باز کنید و بر روی Add User بزنید. سپس QR Code زیر را اسکن کنید. لطفا حتما از کدها یک پشتیبان تهیه کند.",
  "LoginLog.Section3": "۳. می‌توانید بجای اسکن QR Code، کد زیر را کپی و استفاده کنید.",
  "LoginLog.Section4": "۴. عدد ۶ رقمی که از نرم افزار دریافت کرده‌اید را اینجا وارد کنید.",
  "LoginLog.key": "کد:",
  "LoginLog.InputPlaceholder": "لطفا کد ۶ رقمی را اینجا وارد کنید.",
  "LoginLog.CloseTip":
    "غیرفعال کردن Google Authenticator ریسک امنیتی بالایی برای شما ایجاد می‌کند و توصیه نمی‌شود.",
  "LoginLog.SuccessTip":
    "برای ورود، برداشت و تنظیم آدرس‌های حساب‌ها نیاز به ورود کد Google خواهید داشت.",
  "LoginLog.SuccessText": "با موفقیت انجام شد",
  "LoginLog.CloseTitle": "ورود دو مرحله‌ای با گوگل غیرفعال شد",
  "LoginLog.OpenAgain": "شما می‌توانید در هر زمان دیگر ورود دو مرحله‌ای با گوگل را فعال کنید.",

  // footer
  "Footer.Products": "محصولات",
  "Footer.Pool": "اکساتوشی",
  "Footer.Lastpurse": "Lastpurse",
  "Footer.Help": "راهنما",
  "footer.MiningSet": "Mining allocation",
  "Footer.Notice": "Notice",
  "Footer.Guide": "Guide",
  "Footer.Feedback": "بازخورد",
  "Footer.Aboutus": "درباره ما",
  "Footer.Cooperation": "همکاری با ما",
  "Footer.CustomerServices": "خدمات مشتریان",
  "Footer.Links": "پشتیبانی و تماس",
  "Footer.AddWeChat": "Add WeChat Customer Services",
  "Footer.copy": "Copy",
  "Footer.QQGroup": "QQ Group",
  "Footer.Android": "Android version",
  "Footer.Link": "Link",
  "Footer.Blockchain": "Blockchain.cn",
  "Footer.blockchair": "Blockchair",
  "Footer.recordNumber": " ",

  //IndexPage
  "SubTab.Earning": "تاریخچه درآمدها",
  "SubTab.Withdraw": "تاریخچه برداشت‌ها",
  "SubTab.Changetab": "تبدیل‌ها",
  "SubTab.Switch": "تاریخچه ماینینگ هوشمند",
  "SubTab.BSV2BTC": "BSV به BTC",
  "IndexPage.Redeem": "Redeem to BTC",
  "IndexPage.Repayment": "Joint mining amount",
  "IndexPage.history": "تاریخچه",
  "SubTab.ExportTable": "گرفتن خروجی",
  "Notice.More": "بیشتر",
  "IndexPage.totalHashrates": "مجموع هش‌ها",
  "IndexPage.totalHashratesTips": "Summary data for all sub-accounts hashrates",
  "IndexPage.SubHashratesTips": "Summary data of current sub-accounts hashrates",
  "IndexPage.realTime": "زنده",
  "IndexPage.hour24": "امروز",
  "IndexPage.totalMiners": "مجموع ماینرها",
  "IndexPage.totalMinersTips1": "Summary data for all sub-accounts miners",
  "IndexPage.SubMinersTips1": "Summary data of current sub-accounts miners",
  "IndexPage.totalMinersTips2": "Normal:smooth running miner",
  "IndexPage.totalMinersTips3":
    "Low speed:The real-time hashrate of a single miner is 5 times lower than the rated hashrater or 80% of the 24-hour hashrate.",
  "IndexPage.totalMinersTips4": "Offline: miner did not submit new shares for 30 minutes",
  "IndexPage.online": "متوسط",
  "IndexPage.onlineTip": "Online = متوسط + پایین",
  "IndexPage.low": "پایین",
  "IndexPage.offline": "آفلاین",
  "IndexPage.Last24hours": "درآمد آخرین روز",
  "IndexPage.BTC": "BTC",
  "IndexPage.BSV": "BSV",
  "IndexPage.Last24hoursTips":
    "Last day earns were between UTC 0:00-24:00(UTC+8 from 8:00 to 8:00 today)",
  "IndexPage.todayEstimate": "برآورد امروز",
  "IndexPage.todayEstimateTip":
    "The expected gains today are affected by the operation of the miners and the network difficulty. ",
  "IndexPage.list": "فهرست حساب‌ها",
  "IndexPage.addAccount": "افزودن حساب فرعی",
  "IndexPage.NewSubAccount": "اقزودن حساب فرعی",
  "IndexPage.accountName": "حساب فرعی",
  "IndexPage.chooseCoin": "Initial mining currency : ",
  "IndexPage.Earning": "Earnings estimate (1P*24h)",
  "IndexPage.Higher": "بالاتر",
  "IndexPage.Submit": "ارسال",
  "IndexPage.Cancel": "لغو",
  "IndexPage.Account": "حساب",
  "IndexPage.MinersOnOff": "Miners(OK/Low/Off)",
  "IndexPage.RealTime": "بصورت زنده",
  "IndexPage.RealTimeTips": "The last 15 minutes of average hashrate",
  "IndexPage.24hour": "۲۴ ساعت",
  "IndexPage.24hourTips": "The last 24 hours of average hashrate",
  "IndexPage.dailyPower": "روزانه",
  "IndexPage.dailyPowerTips": "The average hashrates of the day",
  "IndexPage.CoinType": "Currency",
  "IndexPage.change": "Intelligent switch",
  "IndexPage.On": "روشن",
  "IndexPage.Off": "خاموش",
  "IndexPage.changeTips": "Selected earns currency",
  "IndexPage.coinEarn":
    "The selected revenue currency, the mining pool will use smart switching to bring more earns to users",
  "IndexPage.Balance": "درآمد",
  "IndexPage.Detail": "جزییات",
  "IndexPage.chartList": "نمودارها",
  "IndexCharts.24hour": "۲۴ ساعت",
  "IndexCharts.7day": "۷ روز",
  "IndexCharts.mounth": "۱ ماه",
  "IndexCharts.3mounth": "۳ ماه",
  "IndexCharts.6mounth": "۶ ماه",
  "IndexCharts.year": "یکسال",
  "IndexCharts.all": "کل",
  "IndexCharts.PerHour": "در ساعت",
  "IndexCharts.PerDay": "در روز",
  "IndexCharts.power": "آمار قدرت هش",
  "IndexCharts.miner": "آمار ماینرها",
  "IndexCharts.income": "آمار درآمدها",
  "IndexCharts.Hashrate": "Unstable hashrate?",
  "IndexPage.Optional": "اختیاری",
  "IndexPage.miner": "ماینر",
  "IndexPage.totalMiner": "آمار ماینرها",
  "IndexPage.totalEarn": "درآمدها",
  "IndexPage.setTriggerValue": "Trigger value",
  "IndexPage.IncomeHeigher": "Yield difference when switching",
  "IndexPage.longTime": "مدت",
  "IndexPage.switchDeriction": "Direction",
  "IndexPage.Ongoing": "Ongoing",
  "indexPage.mainEarnTip": "Summary data for all sub-accounts miners",
  "IndexPage.Estimate": "Estimate",
  "IndexPage.Repayment Record": "Joint mining",
  "IndexPage.ChargeData Record": "",
  "IndexPage.Update": "Upate Date",
  "IndexPage.DailyBack": "Daily earns",
  "IndexPage.Accumulated Repayment": "Total earns",
  "IndexPage.Minus digital currency": "Digital currency deduction",
  "IndexPage.Price per day": "Price",
  "IndexPage.PriceInfo": "OKEX exchange daily trading price at 8am (UTC+8)",
  "IndexPage.standard": "Standard",
  "IndexPage.smart": "Intelligent",

  //About
  "About.us": "About Us",
  "About.p1":
    "Mempool was founded in November 2018, it is to provide users with BTC and BSV mining services Bitcoin mining pool, but also the country's leading BSV mining pool.",
  "About.p2":
    "With AsicBoost technology, it can greatly reduce energy consumption, improve mining efficiency, and create higher and more benefits for users. “Real-time monitoring of mining machine , automatic switching of currency, automatic mining of mine, and transparent revenues of user”,  Mempool believes that the Nakamoto vision described in the original Bitcoin white paper is dedicated to creating a safe and stable digital pool currency.",
  "About.p3":
    "Mempool supports the Web and the Android. We will open the IOS soon, for users can enjoy the efficient and transparent mining pool services anytime and anywhere.",
  "About.company": "About Boquan Network",
  "About.c_p1":
    "Boquan Network was founded in June 2016.We are a company dedicating to technological innovation, focusing on the Blockchain Field. We are committing to Internet R&D in the Blockchainand digital currency sectors.",
  "About.c_p2":
    "Boquan possess a global Top5 mining farm and rich product line, including BCH wallet, Blockchain browser, Cloud computing power, mining pool, mining farm.",
  "About.c_p3":
    "Our target is to create an ecological circular to use the Blockchain to change the world.",
  "About.nourpoolTip1":
    "Nourpool is a next-generation BSV/BTC mining pool aiming to provide class-leading reliability, innovative service model and exceptional customer experience to miners.",
  "About.nourpoolTip2":
    "Founded in October 2019 in Shenzhen by a team that consists of experienced bitcoin miners and ex-developers from Microsoft and Baidu, Nourpool sets from the beginning to fulfilll the the original Satoshi's Vision. More professional services for the BSV eco-system are to come in 2020.",

  // CustomerServices
  "CustomerServices.Customer_Services": "Customer Services",
  "CustomerServices.Contact_Us": "Contact",
  "CustomerServices.Que": "Que",
  "CustomerServices.XiaoMing": "XiaoMing",
  "CustomerServices.tel": "Tel：",
  "CustomerServices.Email": "Email：",
  "CustomerServices.Online_Time": "Online Time: From 10:00 AM to 10:00 PM on each Weekday",
  "CustomerServices.Email_us_or_Message":
    "Email us or Message us if you have problems on weekend,We will reply as soon as possible.Thank you! ",
  "CustomerServices.Follow_Us": "Follow Us",
  "CustomerServices.QQ": "QQ Official Group:",
  "CustomerServices.wx": "follow WeChat public accounts ",

  // SubSettingObserver
  "SubSettingObserver.WatcherSetting": "Watcher setting",
  "SubSettingObserver.WatcherAccount": "Watcher account",
  "SubSettingObserver.WatcherPlaceholder":
    "Please enter the full watcher primary account name to be added",
  "SubSettingObserver.AddedAccount": "Added account",
  "SubSettingObserver.ShareLink": "Shared link",
  "SubSettingObserver.WatcherTipsLeft": "Watcher can view the data of the sub-account",
  "SubSettingObserver.WatcherTipsRight":
    "through the above link, but cannot operate or modify your sub-account.",
  "SubSettingObserver.Set": "تنظیم",
  "SubSettingObserver.AuthorizedAccount": "Authorized account",
  "SubSettingObserver.Close": "Close",
  "SubSettingObserver.None": "None",
  "SubSettingObserver.DeleteText": "Make sure to delete the authorized account ",
  "SubSettingObserver.CopySuccess": "Successful copy",
  "SubSettingObserver.ObserverLink": "Copy observer link",
  "SubSettingObserver.Ok": "Ok",

  "NoData.Text": "بدون داده",

  Back: "بازگشت",
  Home: "خانه",
  //IndexPage
  "IndexPage.FrozenMoney": "Locked",
  "IndexPage.FrozenTips1": "The proceeds from FPPLNS will be temporarily frozen ",
  "IndexPage.FrozenTips2": "and will need to be received after 100 confirmations.",

  "IndexPage.earning.MiningDate": "Mine date",
  "IndexPage.earning.MiningDateTips1": "The bill generation date daily 8:30 (UTC+8)",
  "IndexPage.earning.MiningDateTips2": "Mining date is UTC time",
  "IndexPage.earning.Hashrate": "Hashrate",
  "IndexPage.earning.HashrateTips": "Average hashrate of mining date",
  "IndexPage.earning.settleWay": "Payment Structure",
  "IndexPage.earning.Lucky": "Lucky",
  "IndexPage.earning.LuckyTips": "The actual number of blocks / theoretical number of blocks",
  "IndexPage.earning.FrozenTip":
    "More earnings must wait until 100 confirmations before they can arrive.",
  "IndexPage.earning.FPPS": "FPPS additional revenue included:",

  "IndexPage.withdraw": "Withdraw",
  "IndexPage.withdraw.Time": "Time",
  "IndexPage.withdraw.Fee": "Fees",
  "IndexPage.withdraw.Address": "withdrawal address",
  "IndexPage.withdraw.Status": "Status",
  "IndexPage.withdraw.AccountId": "TXID",
  "IndexPage.withdraw.Paid": "Paid",
  "IndexPage.withdraw.NoPassed": "Refuse to pay",
  "IndexPage.withdraw.ToBeProcess": "To be processed",
  "IndexPage.withdraw.Processing": "Processing",

  "IndexPage.exchange.changeTime": "Currency Time",
  "IndexPage.exchange.Exchanged": "Exchanged",
  "IndexPage.exchange.InExchange": "In exchange",
  "IndexPage.exchange.NoChange": "Exchange failure",

  "IndexPage.Miner.ExportMiner": "Export miner information",
  "IndexPage.Miner.Miners": "Miners",
  "IndexPage.Miner.online": "Online",
  "IndexPage.Miner.RejectRate": "Reject Rate",

  "IndexPage.Miner.All": "All",
  "IndexPage.Miner.Online": "Online",
  "IndexPage.Miner.Low": "Low",
  "IndexPage.Miner.Offline": "Offline",

  "IndexPage.Miner.LastShare": "Last Share",
  "IndexPage.Miner.DefaultGroup": "Default group",
  "IndexPage.Miner.AddGroup": "Add group",
  "IndexPage.Miner.GroupName": "Group name",
  "IndexPage.Miner.EditGroupName": "Edit group",
  "IndexPage.Miner.PlaceholderGroup": "Enter group name",
  "IndexPage.Miner.LowMiner":
    "Low-miner,:the hash of a single miner is less than 80% of the hashrate for 5 consecutive times.",
  "IndexPage.Miner.Hashrate": "Single miner rated hashrate",
  "IndexPage.Miner.HashrateTips": "Please input rated hashrate",
  "IndexPage.Miner.DelGroupTips1": "After deleting the group ",
  "IndexPage.Miner.DelGroupTips2": "  , miners will be assigned to the default group.",
  "IndexPage.Miner.Continue": "Continue",
  "IndexPage.Miner.InputMinerName": "Enter miner name",
  "IndexPage.Miner.MoveTo": "Move to",
  "IndexPage.Miner.RunTime": "Statistical running time",
  "IndexPage.Miner.Time": "Time",
  "IndexPage.Miner.Electricity": "Statistical electricity bill",
  "IndexPage.Miner.ChangeGroup": "Move miners",
  "IndexPage.Miner.clear": "Clear offline miners",
  "IndexPage.Miner.clearText": "Are you sure you want to clear the offline miners?",
  "IndexPage.Miner.moveToGroup": "Move miners to",

  "IndexPage.Exchange": "Easy exchange",
  "IndexPage.ToPlaceholder": "Enter the number of BTCs to be exchanged",
  "IndexPage.Ava": "Available",
  "IndexPage.MinExchange": "کمترین مقدار برای تبدیل ۰.۰۱ BTC است.",
  "IndexPage.ExpectdExchange": "Expected exchangeable",
  "IndexPage.ExchangeTip1": "charges ",
  "IndexPage.ExchangeTip2":
    " exchange fee, The actual amount of exchange should be based on the transaction price.",
  "IndexPage.CurrentExchangeRate": "Current exchange rate",
  "IndexPage.ExchangeAll": "Exchange all",

  "IndexPage.BTCButton": "Withdraw BTC",
  "IndexPage.BSVButton": "Withdraw BSV",
  "IndexPage.fee": "Fee",
  "IndexPage.feeTips1": "The estimated cost of a single transaction is",
  "IndexPage.widthDrawTips": "Please enter the withdrawal amount",
  "IndexPage.feeTips2": ",Please refer to the time of payment",
  "IndexPage.TransferInfo": "Confirm withdrawal information",
  "IndexPage.Amount": "Amount",
  "IndexPage.AmountAll": "Withdraw Amount",
  "IndexPage.widthDrawAll": "Withdraw All",
  "IndexPage.Address": "آدرس",
  "IndexPage.MoreSub": "Multi-sub-account withdrawal",
  "IndexPage.GoogleTitle": "Google verification",
  "IndexPage.InputPlaceholder": "Please enter google verification code",
  "IndexPage.WithdrawTips.title": "Description",
  "IndexPage.WithdrawTips.tips1":
    "For your financial security, the following situations may trigger a manual review:",
  "IndexPage.WithdrawTips.tips2": "1.First withdrawal;",
  "IndexPage.WithdrawTips.tips3": "2.Large withdrawals;",
  "IndexPage.WithdrawTips.tips4": "3.Change the withdrawal address;",
  "IndexPage.WithdrawTips.tips5": "4.Other security issues.",
  "IndexPage.WithdrawTips.tips6":
    "If a manual review is triggered, we will complete the review within 2 hours, and the review time is from 10:00 to 19:00 (UTC+8) on weekdays.",
  "IndexPage.WithdrawTips.tips7":
    "Non-working time review time may be extended, for your financial security, please understand.",

  "IndexPage.MiningSet": "Mining Setting",
  "IndexPage.AiMining": "Intelligent mining",
  "IndexPage.IntelligentTips":
    "According to the income changes of BTC and BSV, choose high-yielding currency for mining",
  "IndexPage.TriggerValue": "Trigger value",
  "IndexPage.TriggerValueTip": "Trigger value required",
  "IndexPage.TriggerValueTips":
    " Switch when the price difference between BTC and BSV reaches the trigger value. The minimum value is 1%",
  "IndexPage.MinerEarn": "Earns",
  "IndexPage.Payout": "Revenue pattern",
  "IndexPage.AddressSet": "تنظیمات آدرس",
  "IndexPage.UseAccountAddr1": "Use the primary account",
  "IndexPage.UseAccountAddr2": "آدرس",
  "IndexPage.withDrawTips1": "Do not fill in an address or mobile number other than ",
  "IndexPage.withDrawTips2": " to avoid withdrawal to the wrong address",
  "IndexPage.AlarmSetting": "Monitoring settings",
  "IndexPage.AlarmSwitch": "Monitoring switch",
  "IndexPage.HashRateAlarm": "Hashrate alarm",
  "IndexPage.ActiveMiners": "Miners alarm",
  "IndexPage.AlarmInterval": "Alarm interval",
  "IndexPage.AlarmEmail": "Contact eamil",
  "IndexPage.AlarmMobile": "Contact mobile number",
  "IndexPage.WatcherAccountList": "Watcher",
  "IndexPage.WatcherSetting": "Watcher setting",
  "IndexPage.WatcherAccount": "Watcher account",
  "IndexPage.WatcherPlaceholder": "Please enter the full watcher primary account name to be added",
  "IndexPage.AddedAccount": "Added account",
  "IndexPage.ShareLink": "Shared link",
  "IndexPage.WatcherTipsLeft":
    "Watcher can view the data of the sub-account through the above link,",
  "IndexPage.WatcherTipsRight": "but cannot operate or modify your sub-account.",
  "IndexPage.HashRateTooltip":
    "When hashrate is lower than the value, sending an alarm to the set contact",
  "IndexPage.ActiveMinersTooltip":
    "When active miners lower than the value,sending an alarm to the set contact",
  "IndexPage.AlarmIntervalTooltip":
    "Continuous alarm 3 times per day according to the set alarm interval",
  "IndexPage.EmailTooltip": "For receiving alarm emails, up to 3 can be set",
  "IndexPage.MobileTooltip": "For receiving alarm messages, up to 3 can be set",
  "IndexPage.HalfHour": "نیم ساعت",
  "IndexPage.AnHour": "یکساعت",
  "IndexPage.TwoHour": "۲ ساعت",
  "IndexPage.UseSub": "Apply to all subaccounts",
  "IndexPage.valueTips": "Please enter a value from 1 to 100, accurate to 2 decimal places",
  "IndexPage.changeModeTip": "Revenue mode switch, effective at 8:00 (UTC + 8) the next day",
  "IndexPage.changeMinerTip1": "The revenue pattern will switch to ",
  "IndexPage.changeMinerTip2": " on the second day UTC + 8 8:00",
  "IndexPage.minute": "دقیقه",
  "IndexPage.hour": "ساعت",
  "IndexPage.day": "روز",

  "IndexPage.Replenishment": "Replenishment record",
  "IndexPage.ReplenishmentTime": "Replenishment time",

  // 共享费率
  "IndexPage.DepositBSV": "Deposit BSV",
  "IndexPage.PayAddress": "آدرس",
  "IndexPage.NewAddress": "آدرس جدید",
  "IndexPage.Text1": "Please transfer BSV to the above address",
  "IndexPage.Text2":
    "When the number of confirmations exceeds 3, the amount will be synchronized to the account.",
  "IndexPage.Text3": "Please wait 1 minute after transfer to check the result.",
  "WithDraw.low": "Low",
  "WithDraw.height": "Height",

  "IndexPage.noAccountTips1": "No sub-account created",
  "IndexPage.noAccountTips2":
    "Please click the New Sub Account button above to create a sub-account and start mining.",
  "IndexPage.steps1":
    "Access to local network and login the background system of miners, fill in the miner name and save the profile. The miners will be automatically added to mempool within one minute.",
  "IndexPage.steps2":
    "Miner's name standard: sub-account+'.'+number, for example, your sub-account is mempool, then your miner name cloud be set as mempool.001, mempool.002.",
  "IndexPage.addressRule1":
    "China mining URL：ss.mempool.com:25     ss.mempool.com:443     ss.mempool.com:1800",
  "IndexPage.addressRule2":
    "International mining URL：ss-eu.mempool.com:25     ss-eu.mempool.com:443     ss-eu.mempool.com:1800",

  "IndexPage.steps2.nourpool":
    "Miner's name standard: sub-account+'.'+number, for example, your sub-account is nourpool, then your miner name cloud be set as nourpool.001、nourpool.002.",
  "IndexPage.addressRule1.nourpool":
    "China mining URL：ss.nourpool.io:25     ss.nourpool.io:443     ss.nourpool.io:1800",
  "IndexPage.addressRule2.nourpool":
    "International mining URL：ss-eu.nourpool.io:25     ss-eu.nourpool.io:443     ss-eu.nourpool.io:1800",

  // Report
  Electricity: "برق مصرفی",
  ElectricTips: "تنظیم مصرف و هزینه برق, برای محاسبه هزینه‌ها",
  Miner: "زمان فعالیت ماینر",
  MinerTips: "زمان فعالیت برای تمام ماینینگ‌ها در یک حساب فرعی را محاسبه می‌کند",
  MonthBill: "صورتحساب ماهانه",
  MonthTips: "در دهم هر ماه یک گزارش با جزییات ماه قبل برای حساب فرعی شما تولید می‌کند",
  Count: "حسابگر",
  View: "مشاهده",
  SubAccount: "حساب فرعی",
  MonthList: "فهرست صورتحسابهای ماهانه",
  Mail_receipt_billing_Settings: "تنظیمات دریافت صورتحساب",
  Mail_receipt_bill: "دریافت صورتحساب",
  To_receive_your_email: "ایمیل: ",
  Delete: "حذف",
  Add: "افزودن",
  New_receiving_mailbox: "افزودن ایمیل",
  GetReport: "صدور گزارش",
  "Report.Mail.tableTip":
    "صورتحساب ماه قبل حساب فرعی در ساعت ۱۰ صبح دهم هر ماه تولید شده و برای دریافت آماده می‌شود. برای دریافت می‌توانید یک ایمیل تنظیم کنید.",
  "Report.Mail.Tips":
    "The monthly bill of the sub-account will be automatically sent to the set receiving mailbox at 10:00 am (UTC+8) on the 10th of the following month. Please check the receipt.",
  "Report.Mail.Tips1":
    "If no receiving email is set up, this contract will no longer automatically send monthly bills",
  "Report.Name": "نام",
  "Report.Time": "تاریخ",
  "Report.Operation": "عملیات",
  "Report.Download": "دریافت",

  "Report.Select": "انتخاب",
  "Report.Elect": "دریافت خروجی از صورتحساب",
  "Report.MinerName": "نام ماینر",
  "Report.RunTime": "از زمان فعالیت خروجی بگیرید",
  "Report.more": "برای مشاهده آمار بیشتر:",
  "Report.Elect.Price": "قیمت برق مصرفی",
  "Report.Elect.PowerWaste": "میزان برق مصرفی",
  "Report.Elect.Data": "داده‌ها",
  "Report.Elect.Other": "سایر",
  "Report.Elect.RunTime": "زمان فعالیت (ساعت)",
  "Report.Elect.OtherFee": "سایر هزینه‌ها",
  "Report.Elect.Cost": "مجموع هزینه ها ",
  "Report.Blank": "خالی",

  // Tool
  "Tool.AppTips":
    "View multiple account mining details,manual withdrawal operation, miner view, sub-account Settings, watcher account view",
  "Tool.SmartAgent": "Mempool smart agent",
  "Tool.SmartAgentInfo":
    "The stratum agent designed for large mining pools can greatly improve the communication efficiency between mines and mining pool.",
  "Tool.MiningCal": "Mini mining calculator",
  "Tool.MiningInfo": "A powerful and easy-to-use mining calculator,support BSV, BTC.",
  "Tool.link": "Count",
  "Tool.windows": "Windows 64",

  // Calculator
  "Cal.Hashrate": "Hashrate",
  "Cal.PPS24": "PPS 24h earns",
  "Cal.FPPS24": "FPPS 24h earns",
  "Cal.About": "Folding legal currency about",
  "Cal.Tips":
    "* Enter the effective power on the top and the theoretical gain on the bottom, enter theoretical income on the bottom and the effective power on the top.",
  "Cal.More": "More",
  "Cal.Close": "Close",
  "Cal.Legal": "Legal currency",
  "Cal.Price": "Currency price",
  "Cal.Diff": "Difficulty",
  "Cal.EarnPPS": "Earnings ratio (PPS)",
  "Cal.EarnFPPS": "Earnings ratio (FPPS)",

  // Agent
  "Agent.TodayIncome": "درآمد امروز",
  "Agent.Cumulative": "کل درآمد",
  "Agent.Text": "Included in the Returns - Withdraw Amount",
  "Agent.Accounts": "حساب‌ها",
  "Agent.Types": "انواع",
  "Agent.EarnedGains": "Earned gains",
  "Agent.Gains": "Expected commission",
  "Agent.Remarks": "Remarks",
  "Agent.Agent": "همکار",
  "Agent.Miner": "ماینر",
  "Agent.Edit": "ویرایش",
  "Agent.EditAccount": "ویرایش حساب",
  "Agent.Income": "Theoretical income",
  "Agent.Create": "همکار جدید",
  "Agent.BTCFee": "BTC handling rate",
  "Agent.BSVFee": "BSV handling rate",
  "Agent.Add": "افزودن",
  "Agent.Success": "حساب با موفقیت ساخته شد!",
  "Agent.New": "جدید",

  // Excel
  "Excel.amount": "Amount",
  "Excel.withDraw.Way": "withdrawal methods",
  "Excel.withDraw.Auto": "Auto",
  "Excel.withDraw.Manual": "Manual",
  "Excel.date": "Date",
  "Excel.BTCEarn": "Earns-BTC",
  "Excel.BTCOther": "Additional Earns-BTC",
  "Excel.BSVEarn": "Earns-BSV",
  "Excel.BSVOther": "Additional Earns-BSV",
  "Excel.BTCAmount": "BTC-amount",
  "Excel.changeTime": "Time",
  "Excel.cahnegRate": "BTC/BSV",
  "Excel.changeBSV": "TX BSV",
  "Excel.minerTitle": "Miners Report",
  "Excel.electricty": "Electricity bill statistics",
  "Excel.runTime": "Miners online time statistics",
  "Excel.getReport": "لطفا ابتدا گزارش را صادر کنید",
  "Excel.report": "دریافت خروجی اکسل",
  "Excel.feeBSV": "Fee(BSV)",
  "Excel.BTCTimeRange": "BTC-accounting time",
  "Excel.BSVTimeRange": "BSV-accounting time",

  // 活动字段
  ZeroRate: "Zero rate",
  "Affix.title1": "0 Rate BSV",
  "Affix.title2": "3.16～4.14",

  // v3.6
  "Loan.repayment": "Loan repayment",
  "Loan.self electricity": "Self-paid electricity",
  "Loan.electricity": "Pay electricity",
  "Loan.freight": "Freight",
  "Loan.maintenance": "Maintenance fees",
  "Loan.shelf": "Shelf fees",
  "Loan.off shelf": "Off shelf fees",
  "Loan.purchase": "Purchase of spare parts",
  "Loan.other": "Other",
  /**
   *
   * MSG请一律放后面
   */
  MSG_input_username: "Please input username",
  MSG_input_password: "Please input password",
  MSG_user_not_exist: "User does not exist",
  MSG_login_fail: "Login failed, please try again",
  MSG_incorrect_input_phone_number_or_mailbox_format: "Account format error",
  MSG_username_or_password_incorrect: "Username or password incorrect",
  MSG_wrong_withdraw_address_format: "Wrong withdraw address format",
  MSG_withdraw_fee_expire: "The submission page has timed out and the latest fee has been reloaded",
  MSG_user_withdraw_address_not_set: "Account withdrawal address is not set",
  MSG_wrong_username_format: "Mobile phone number or email format is incorrect",
  MSG_wrong_password_format: "8-16 passwords contain letters, numbers, special characters",
  MSG_wrong_username: "Input mobile number or email",
  MSG_verify_pass: "Verification passed",
  MSG_exchange_apply_success: "Application submitted",

  "MSG_amount_below_the_minimum_limit_0.005": "The exchange amount must be greater than 0.005",
  MSG_user_failed_to_login_or_expired: "Login expired",
  MSG_login_out_seccess: "Logout success",
  MSG_input_verify_code: "Please input verify code",
  MSG_input_withdraw_address: "Please input withdraw address",
  MSG_edit_success: "Edit success",
  MSG_edit_fail: "Edit fail",
  MSG_input_old_password: "Input old password",
  MSG_input_new_password: "Input new password",
  MSG_input_new_password_confirm: "Input new password confirm",
  MSG_password_inconsistent: "Password inconsistent",
  MSG_wrong_withdraw_amount: "Wrong withdraw amount",
  MSG_amount_below_the_minimum_lit: "Amount below the minimum lit",
  MSG_withdraw_apply_success: "Withdraw request submitted",
  MSG_catch_error: "Catch error",
  MSG_withdraw_address_not_set: "Withdraw address not set",
  MSG_send_success: "Sent successfully",
  MSG_user_password_incorrect: "Wrong password",
  "MSG_amount_below_the_minimum_limit_0.01": "Withdraw amount must be greater than 0.01 BTC",
  "MSG_amount_below_the_minimum_limit_0.001": "Withdraw amount must be greater than 0.001 BSV",
  MSG_user_not_exists: "User does not exsist",
  MSG_add_success: "Rigster success",
  MSG_edit_password_success: "Reset success",
  MSG_edit_password_faile: "Reset failed",
  MSG_edit_password_fail: "Reset failed",
  MSG_edit_password_failed: "Reset failed",
  MSG_set_mobile_success: "Set mobile success",
  MSG_set_email_success: "Set email success",
  MSG_user_mobile_already_exists: "User exists",
  MSG_pay_password_err: "Incorrect password!", //Incorrect password!
  MSG_not_have_token_utx: "lack token!",
  MSG_trans_utx_faile: "Failed to transfer!", //Failed to transfer!
  MSG_not_have_token_addr: "Failed to get address!", //Failed to get address.
  // new
  MSG_please_input_phone_number_or_email: "Email or Phone",
  MSG_user_email_already_exists: "Email already exists.",
  MSG_token_is_ok: "Token is available. ",
  MSG_save_code_fail: "Failed to sent.",
  MSG_user_email_not_exists: "Email not exists.",
  MSG_user_mobile_not_exists: "Phone not exists.",
  MSG_login_out_sucess: "Already login out.",
  MSG_user_email_have: "Email have linked.",
  MSG_user_mobile_have: "Phone have linked.",
  MSG_set_info_success: "Success!",
  MSG_set_userinfo_success: "User information updated.",
  MSG_please_input_username: "Username",
  MSG_need_public_key: "Public-key is null.",
  MSG_userMnemonic_already_backup: "Mnemonics has backed up.",
  MSG_pay_password_not_empty: "Payment password is null.",
  MSG_addr_type_is_only_BSV_BTC: "Only allow BSV or BTC",
  MSG_pay_amount_err: "Pay amount error!",
  MSG_pay_address_err: "Address error!",
  MSG_transfer_to_user_receive_faile: "Failed to transfered.",
  MSG_transfer_money_type_err: "Failed to received.",
  MSG_transfer_money_need_user_id: "Please enter ID.",
  MSG_pay_to_addr_user_id_err: "ID error!",
  MSG_not_pay_to_user_self: "Don’t transfer to yourself.",
  MSG_pay_password_empty: "Payment password is null.",
  MSG_user_money_not_enough: "Out of account balance!",
  MSG_token_is_empty: "code is null",
  MSG_code_is_err: "code is error",
  MSG_account_locked: "The account is locked. Please try again in 15 minutes.",
  MSG_account_locked_three: " Lock account after 3 errors",
  MSG_account_locked_two: "Lock account after 2 errors",
  MSG_account_locked_one: "Lock account after 3 errors",
  MSG_send_mobile_success: "Verification code has been sent to the mobile number",
  MSG_send_email_success: "Verification code has been sent to the email address",
  // 子账户创建提示
  MSG_user_name_type_incorrect:
    "Subaccount name should be 4 to 30 letters or numbers, and lowercase letters only at the beginning of",
  MSG_do_faile: "Creation failed, please try again",
  MSG_the_name_of_the_input_sub_account_already_exists: "Enter sub-account name already exists",
  MSG_user_is_have: "User already exists",
  // MSG_exchange_success: "Exchange success",
  MSG_send_fail: "Send failed",
  MSG_please_input_ga_code: "Enter google verification code",
  MSG_wait_few_seconds_generate: "Please wait a few seconds to generate an address",

  // 提现提示
  "MSG_amount_must_be_greater_than_0.01": "The amount of withdraw must be greater than 0.01",
  MSG_please_set_up_BTC_cash_address_first: "Please set the BTC withdrawal address first",
  MSG_please_set_up_BSV_cash_address_first: "Please set the BSV withdrawal address first",
  MSG_withdraw_success: "Withdrawal of application successfully",
  MSG_withdraw_fail: "Withdrawal of application failed",
  MSG_exchange_success: "Submitted successfully",
  MSG_exchange_fail: "Submission Failed",
  MSG_exchange_amount_must_be_greater_than_0: "The exchange amount is less than 0.01BTC",
  MSG_no_exchange_power: "Unopened permission",
  MSG_cash_amount_must_be_digits: "The withdrawa amount must be a number",
  MSG_cash_application_failed: "Withdrawa request failed",
  MSG_act_success: "Successful operation",
  MSG_unable_to_get_total_account_number: "Unable to get the total account number",
  MSG_amount_must_be_greater_than_0: "The amount of withdraw must be greater than 0.01",
  MSG_account_balance_is_insufficient: "Insufficient account balance",
  MSG_failure_to_application: "Failed to generate withdrawal request record",
  MSG_exchange_amount_not_enough: "The exchange amount is less than 0.01BTC",
  MSG_please_input_bsv_address: "Please input BSV address",
  MSG_please_input_btc_address: "Please input BTC address",
  MSG_please_set_address: "Please set withdrawal address first",
  "MSG_amount_must_be_greater_than_0.00000546":
    "The amount of withdraw must be greater than 0.00000546",
  MSG_input_the_correct_btc_fee_present: "BTC rate error",
  MSG_input_the_correct_bsv_fee_present: "BSV rate error",

  // 导出提示
  MSG_please_input_data_time: "Please enter the start and end times",
  MSG_please_input_data_start: "Please enter the start time",
  MSG_please_input_data_end: "Please enter the end time",
  MSG_please_input_electric_charge: "Please enter the electricity fee",
  MSG_please_input_power: "Please enter power",
  MSG_please_input_other: "Other fee format error",
  MSG_excel_fail: "Export Excel failed",
  MSG_please_input_mobile_or_email: "Input mobile number or email",
  "MSG_exchange_amount_must_be_greater_than_0.01":
    "The exchenge amount must be greater than 0.001 BTC",
  MSG_please_select_monitoring_mode: "Select a monitoring mode",
  MSG_set_up_at_most_three_emails: "Set up to three emails",
  MSG_incorrect_email_format: "Wrong eamil format",
  MSG_set_up_at_most_three_mibiles: "Set up to three mobile numbers",
  MSG_incorrect_mobile_format: "Wrong mobile format",
  MSG_please_input_hash_rate_warn_value: "Input a valid value",
  MSG_please_input_subuser_id: "Please enter subuser ID",

  //
  MSG_incorrect_password_format: "8-16 passwords contain letters, numbers, special characters",
  MSG_verify_code_incorrect: "Verification code error",
  MSG_name_size_less_than_50: "The name can be up to 50 characters long",
  MSG_bind_fail: "Binding failed",
  MSG_secret_expired: "Key expired",
  MSG_ga_code_incorrect: "Google verification code error",
  MSG_please_input_amount: "Please input amount",
  MSG_please_input_amount_btc: "Please input amount",
  MSG_please_input_amount_bsv: "Please input amount",
  MSG_balance_insufficient: "Insufficient balance",
  MSG_balance_insufficient_fee: "Account balance is insufficient to pay the  fee",
  MSG_email_format_incorrect: "Email format error",
  MSG_amount_must_be_greater_than_smallest_amount:
    "Withdraw amount must be greater than minimum limit amount",
  MSG_amount_must_be_greater_than_smallest_amount_btc:
    "Withdraw amount must be greater than minimum limit amount 0.001BTC",
  MSG_amount_must_be_greater_than_smallest_amount_bsv:
    "Withdraw amount must be greater than minimum limit amount 0.001BSV",
  MSG_fill: "Please fill in the required fields",
  MSG_you_can_only_change_it_once_two_hour:
    "Less than 2 hours since the last switch, please try again later",
  MSG_withdraw_amount_illegal: "Incorrect format，please re-enter",

  // 后端重构v3.4新增提示
  MSG_rated_power_err: "Single miner rated hashrate",
  MSG_you_can_only_change_it_once_an_hour: "Revenue mode can only be switched once per hour",
  MSG_input_fee_rate_error: "Incorrect format，please re-enter",
  MSG_amount_percent_err: "Enter a value greater than 0 and less than or equal to 100",
  MSG_add_fail: "Fail to add",
  MSG_data_type_err: "incorrect type",

  // 旧版MSG
  MSG_no_user_id_modify: "Missing user ID to modify",
  MSG_user_phone_number_already_exists: "The  mobile number already exists",
  MSG_please_input_user_name: "Please enter a username",
  MSG_no_user_id_to_delete: "Missing user ID to delete",
  MSG_user_phone_number_not_exist: "User phone number does not exist",
  MSG_lack_of_user_id_to_opened: "Missing user ID to be activated",
  MSG_failure_to_deduct_money: "Deduction failed, there may be insufficient balance",
  MSG_mobile_not_be_empty: "Mobile cant be empty, please check",
  MSG_id_is_empty: "id is empty",
  MSG_no_user_id_to_modify: "Missing user ID to modify",
  MSG_no_content_to_modified: "Missing user ID to modify",
  MSG_incorrect_account_type: "Account type is incorrect",
  MSG_lack_of_withdrawals_id: "Missing withdrawal request ID",
  MSG_please_input_info: "Please enter the remark information such as the transaction number",
  MSG_please_input_pay_password: "Please enter the payment password",
  MSG_pay_password_is_incorrect: "Payment password is incorrect",
  MSG_failed_to_modify_audited:
    "The database modification failed. The information may not be pending",
  MSG_admin_are_not_logged: "Administrator not logged in",
  MSG_do_successfully: "Set successfully",
  MSG_please_enter_mobile: "Please enter the users mobile number",
  MSG_enter_user_permissions: "Please enter the user permission ID",
  MSG_please_input_user_password: "Please enter a user password",
  MSG_add_user_success: "Add user success",
  MSG_add_user_fail: "Add user failed",
  MSG_admin_not_logged: "Administrator not logged in",
  MSG_modify_user_success: "Modify user success",
  MSG_modify_user_fail: "Modify user failed",
  MSG_user_does_not_exist: "User information does not exist",
  MSG_delete_user_success: "Delete user successfully",
  MSG_delete_user_fail: "Delete user failed",
  MSG_lack_of_user_id: "Missing user ID",
  MSG_open_user_success: "Open user success",
  MSG_open_user_fail: "Failed to open user",
  MSG_input_the_correct_mobile: "Please enter the correct mobile",
  MSG_mobile_is_wrong: "The phone number format is incorrect, please check",
  MSG_subaccount_is_incorrect: "The sub-account id entered is incorrect",
  MSG_please_input_correct_settlement: "Please enter the correct billing method",
  MSG_input_id_is_wrong: "The input subordinate id is incorrect, please check",
  MSG_can_not_switch: "Cant switch",
  MSG_do_not_switch_to_current_mode: "Cannot switch to the current mode",
  MSG_you_can_only_change_it_once_a_day: "Can only be modified once a day",
  MSG_switch_error_please_try_again: "Switching error, please try again",
  MSG_input_at_least_one_modification_parameter: "Please enter at least one modification parameter",
  MSG_input_the_correct_proportion: "Please enter the correct draw ratio",
  MSG_get_sub_account_list: "Get a list of sub accounts",
  MSG_input_login_name: "Please enter your login name",
  MSG_sub_account_does_not_exist: "This sub-account does not exist, please check",
  MSG_failed_to_modify_sub_account: "Failed to modify sub-account information",
  MSG_the_number_of_sub_accounts_is_incorrect:
    "The number of sub-accounts is incorrect. Please check",
  MSG_verify_fail: "Verification failed",
  MSG_authentication_failed: "Authentication failed, please login",
  MSG_fail_please_check: "The query failed, please check",
  MSG_send_successfully: "Sent successfully",
  MSG_id_incorrect: "The input id is incorrect, please check",
  MSG_can_only_switch_to_pps: "Can only switch to PPS",
  MSG_user_no_login: "User not logged in",
  MSG_no_permission: "No create permission",
  MSG_The_settlement_method_can_only_be_FPPS_or_FPPLNS: "Settlement can only be FPPS or FPPLNS",
  MSG_The_settlement_method_can_only_be_FPPS: "Settlement can only be FPPS",
  MSG_The_settlement_method_can_only_be_PPS: "Settlement can only be PPS",
  MSG_delete_faile: "Deleting user failed",
  MSG_delete_sucess: "Delete user successfully",
  MSG_the_old_password_entered_is_empty: "The old password entered is empty, please check",
  MSG_the_new_password_entered_is_empty: "The new password entered is empty, please check",
  MSG_incorrectpasswordformat:
    "Password must be 8 to 16 digits, containing at least one letter, one number, one special character",
  MSG_the_number_of_sub_users_is_not_compliant:
    "The number of sub-users is not compliant, please check",
  MSG_please_input: "Please enter information",
  MSG_please_input_mobile_or_eamil: "Please enter your mobile number or email address",
  MSG_input_the_proportion: "Please enter the proportion",
  MSG_please_input_right_user_type: "Please enter the correct user type",
  MSG_input_the_correct_default_settlement_method: "Please enter the correct default settlement",
  MSG_please_input_user_id: "Please enter the user id",
  MSG_please_enter_verification_code: "Please enter verification code",
  MSG_addr_incorrect: "The address type to be modified is incorrect",
  MSG_can_not_get_mobile_or_email: "Unable to get phone number or emai",
  MSG_please_input_days: "Please enter the number of days to count",
  MSG_please_input_type: "Please enter the address to be modified",
  MSG_please_enter_addr: "Please enter the withdrawal address to be set",
  MSG_code_incorrect: "Incorrect verification code",
  MSG_send_verify_code_fail: "Send verification code failed",
  MSG_input_invite_code: "Pleaes input invitation code",
  MSG_invite_code_incorrect: "Invitation code error",
  MSG_invite_code_expired: "Invitation code has expired",
  MSG_user_name_length_incorrect: "Sub-account name should be between 4-30 digits in length",
  MSG_reset_password_fail: "MSG_reset_password_fail",
  MSG_reset_password_success: "Reset password successfully",
  MSG_rated_power_not_is_empty: "Rated hashrate is empty",
  MSG_input_the_correct_auto_switch_rate: "The trigger value should be between 1% and 100%",
  MSG_binding_user_inconsistent:
    "This WeChat is not bound to the mine pool account and cannot be unbound",
  MSG_bound_user: "This account has been bound with other WeChat ID, please unbind and try again",
};

export default Lang;
